module.exports = __webpack_public_path__ + "img/location-1-upcoming.bfcd8f92.png";